// Redux slice for handling resend email verification
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';
// Thunk for resending email verification
export const resendEmailVerification = createAsyncThunk(
  'customer/resendEmailVerification',
  async ({ customerName, phoneNumber, taxId }, { rejectWithValue }) => {
   
    // {
    //   customerName: "5555",
    //   taxId: "55555",
    //   phoneNumber: "44444"
    // }
    try {
      const response = await axiosInstance.post('/api/Customer/ResendEmailVerification', {
        CustomerName: customerName,
        PhoneNumber: phoneNumber,
        TaxId: taxId,
      } , {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json-patch+json', // Or change to 'application/json'
        }
      });
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data.errormessage || 'Unknown error occurred');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.errormessage || error.message);
    }
  }
);

const resendEmailVerificationSlice = createSlice({
  name: 'resendEmail',
  initialState: {
    loading: false,
    successMessage: '',
    errorMessage: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resendEmailVerification.pending, (state) => {
        state.loading = true;
      })
      .addCase(resendEmailVerification.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message || 'Verification email resent successfully';
      })
      .addCase(resendEmailVerification.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload || 'Failed to resend email verification';
      });
  },
});

export default resendEmailVerificationSlice.reducer;
